import * as React from "react"

// @ts-ignore
import footerLogo from '../../assets/uc-sigill-txt-white.png'

// @ts-ignore
import styles from "./Footer.module.scss"

export function Footer({ LinkComponent }) {
  return (
    <footer className={styles.Footer}>
      <div className={styles.container}>
        <div className={styles.banner}/>

        <div className={styles.menusWrapper}>
          <div className={styles.menuColumn}>
            <h3 className={styles.menuTitle}>Företag</h3>

            <div className={styles.links}>
              <LinkComponent to="/om-oss">Om Oss</LinkComponent>
              <LinkComponent to="/medarbetare">Våra Medarbetare</LinkComponent>
              <LinkComponent to="/jobba-hos-oss">Jobba Hos Oss</LinkComponent>
              <LinkComponent to="/kontakta-oss">Kontakta Oss</LinkComponent>
            </div>
          </div>

          <div className={styles.menuColumn}>
            <h3 className={styles.menuTitle}>Tjänster & Övrigt</h3>

            <div className={styles.links}>
              <LinkComponent to="/avveckla-aktiebolag">Avveckla AB</LinkComponent>
              <LinkComponent to="/kopa-lagerbolag">Lagerbolag</LinkComponent>
              <div className={styles.inline}>
                <LinkComponent to="/kopa-lagerbolag/kopa-aktiebolag">Köpa</LinkComponent>
                <span className={styles.linkDivider}>/</span>
                <LinkComponent to="/avveckla-aktiebolag/salja-aktiebolag">Sälja AB</LinkComponent>
              </div>
              <LinkComponent to="/kopa-lagerbolag/starta-aktiebolag">Starta Aktiebolag</LinkComponent>
            </div>
          </div>

          <div className={styles.menuColumn}>
            <h3 className={styles.noTitle}>&nbsp;</h3>

            <div className={styles.links}>
              <LinkComponent to="/avveckla-aktiebolag/snabbavveckling">Snabbavveckling</LinkComponent>
              <LinkComponent to="/avveckla-aktiebolag/likvidera-aktiebolag">Likvidation</LinkComponent>
              <LinkComponent to="/avveckla-aktiebolag/aktiebolag-fran-start-till-avslut">Aktiebolag</LinkComponent>
              <LinkComponent to="/artiklar">Fler artiklar...</LinkComponent>
            </div>
          </div>

          <div className={styles.logoColumn}>
            <a href="https://www.uc.se/risksigill2?showorg=5568279367&language=swe" target="_blank" rel="noreferrer">
              <img
                className={styles.footerLogo}
                src={footerLogo}
                alt='UC sigill logo'
              />
            </a>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p className={styles.text}>
            © 2012-{new Date().getFullYear()} Citadellet Bolagsservice AB - Alla
            rättigheter reserverade.
          </p>
        </div>
      </div>
    </footer>
  )
}
